<template>
  <div class="flex items-center justify-between flex-wrap mb-[20px] gap-[0.45rem]">
    <div class="flex items-center flex-wrap gap-[0.45rem]">
      <span class="flex items-center justify-center px-[12px] py-[4px] rounded-[6px] bg-[#FFF3EE] text-[#F15A24] h-[36px] text-sm font-medium">
        {{ total }} Artikel
      </span>
      <b-form-group class="mb-0 w-[300px]">
        <b-input-group class="input-group-merge">
          <b-form-input
            v-model="localSearch"
            :placeholder="config.text.searchPlaceholder"
            @input="onSearchInput"
          />
          <b-input-group-append
            is-text
            class="border-l-[2px] border-[#E5E5E5]"
          >
            <feather-icon
              icon="SearchIcon"
              size="16"
            />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <div class="flex items-center flex-wrap gap-[0.75rem]">
      <article-bulk-action
        v-if="hasSelected"
        @bulk-action="$emit('bulk-action', $event)"
      />

      <template v-else>
        <v-select
          v-model="localStatus"
          :options="config.statusOptions"
          :reduce="item => item.value"
          label="text"
          :clearable="false"
          class="min-w-[120px] shadow-[0px_1px_0px_0px_#0000000D] !rounded-[8px]"
          @input="$emit('status-change', localStatus)"
        />
      </template>
      <b-button
        variant="primary"
        class="!font-normal !rounded-[8px] !text-[14px] d-flex align-items-center gap-[8px] !py-0 !h-[36px]"
        :to="{ name: 'EditorArtikel' }"
      >
        <feather-icon
          icon="PlusIcon"
          size="16"
        />
        <span>{{ config.text.btnAdd }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { debounce } from 'lodash'
import ArticleBulkAction from './ArticleBulkAction.vue'
import { ARTIKEL_CONFIG } from './config'

export default {
  name: 'ArtikelHeader',
  components: {
    vSelect,
    ArticleBulkAction,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: null,
    },
    hasSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      config: ARTIKEL_CONFIG,
      localSearch: this.search,
      localStatus: this.status,
    }
  },

  watch: {
    // Keep local copies in sync when the parent updates the search/status props
    search(val) {
      this.localSearch = val
    },
    status(val) {
      this.localStatus = val
    },
  },

  methods: {
    onSearchInput(val) {
      const cleanedVal = val.trim()

      if (val.length > 0 && cleanedVal.length === 0) return

      if (cleanedVal.length > 0 && cleanedVal.length < 3) return

      this.debouncedSearch(cleanedVal)
    },
    /**
     * Emits the 'search' event to the parent with a 500 ms debounce
     * to avoid excessive API calls while the user is typing.
     * @param {string} val - The search keyword
     */
    debouncedSearch: debounce(function debouncedSearch(val) {
      this.$emit('search', val)
    }, 500),
  },
}
</script>
